// extracted by mini-css-extract-plugin
export default {"wrapper":"Ly-z","button":"My-z","alternate":"Ny-z","disabled":"Oy-z","paymentWarning":"Py-z","fadeIn":"Qy-z"};